module.exports = __webpack_public_path__ + "static/media/background_circle_green.11721b8d.svg";